export default "__VITE_ASSET__BDULASvf__"